import { DropDownView, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';
import { WorkspaceFilter } from './workspaceFilter';

type WorkspaceFilterMenuProps = {
  onWorkspaceFilterOpen: () => void;
  onWorkspaceFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
};

export const WorkspaceFilterMenu = ({
  onWorkspaceFilterClose,
  onWorkspaceFilterOpen,
  isOpened,
  anchorRef,
  type,
}: WorkspaceFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onWorkspaceFilterClose}
    >
      <WorkspaceFilter onCloseSideBar={onWorkspaceFilterClose} type={type} />
    </DropDownView>
  );
};
